import React from 'react';
import { PlayButton as RobloxPlayButton } from 'Roblox';
import metadataConstants from '../constants/metadataConstants';

export default function PlayButton(): JSX.Element {
  const { universeId = '', placeId = '' } = metadataConstants.metadataData() || {};
  const universeNumber = parseInt(universeId, 10);
  const placeNumber = parseInt(placeId, 10);
  return <RobloxPlayButton placeId={placeNumber} universeId={universeNumber} />;
}
